import React from 'react'
import { CarCasesBadgeProvider } from 'contexts/CarCasesBadgeContext'
import useCarCasesBadge from 'utils/hooks/useCarCasesBadge'

/**
 * Provider component that wraps the badge hook and provides count, loading, and refresh to children
 * This ensures only one instance of the hook runs and makes data available throughout the app
 */
const CarCasesBadgeProviderWrapper = ({ children }) => {
    const { count, loading, refresh } = useCarCasesBadge()

    // Ensure we always have valid values (defensive check)
    const safeCount = typeof count === 'number' ? count : 0
    const safeLoading = typeof loading === 'boolean' ? loading : false
    const safeRefresh = typeof refresh === 'function' ? refresh : () => {}

    return (
        <CarCasesBadgeProvider 
            count={safeCount} 
            loading={safeLoading} 
            refresh={safeRefresh}
        >
            {children}
        </CarCasesBadgeProvider>
    )
}

export default CarCasesBadgeProviderWrapper

